var _rect, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "#012169"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 3l.6 1.5 1.6.1-1.2 1 .4 1.6L21 6.3l-1.4.9.4-1.6-1.2-1 1.6-.1zm4.5 7l.5 1.2 1.3.1-1 .8.4 1.3-1.2-.7-1.1.7.3-1.3-1-.8 1.3-.1zm-6 4l.5 1.2 1.3.1-1 .8.4 1.3-1.2-.7-1.1.7.3-1.3-1-.8 1.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12 8M12 0L0 8",
    stroke: "#fff",
    strokeWidth: 2.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12 8M12 0L0 8",
    stroke: "#c8102e",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0v8M0 4h12",
    stroke: "#fff",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0v8M0 4h12",
    stroke: "#c8102e",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/au.8f5f8a19636580681bec52e4f64bbaee.svg";
export { ForwardRef as ReactComponent };